import { LibraryDocument } from './LibraryBase';
import { Paged } from './Misc';
import { Operation } from './Operation';
import { User } from './User';

export enum QueryGroup {
  All = 'ALL',
  Preparation = 'PREP',
  Execution = 'EXEC',
}

export interface MissionItem {
  id: number;
  number: string;
  type: string;
  startDate: string;
  endDate: string;
  status: string;
  destinationCountry: string;
  regionCountry: string;
  objective: string;

  operationId: number;
  operationNumber: string;
  operationName: string;
  operationType: string;
  operationEsrr: string;
  operationEsic: string;
  operationDccrc: string;
  operationSpr: string;
  members: string;
}

export interface MissionUser {
  id: number;
  fullName: string;
  group: string;
  email: string;
}

export type MissionDocument = LibraryDocument;

export interface Mission {
  id: number;
  number: string;
  type: string;
  startDate: string;
  endDate: string;
  status: string;
  destinationCountry: string;
  objective: string;
  country: string;
  memberList: MissionUser[];
  documents: MissionDocument[];
  documentDraft: MissionDocument;
  operation: Operation;
}

export interface MissionContainer {
  mission: Mission;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface MissionList extends Paged<MissionItem> {}

export interface MissionFilterBase {
  queryGroup: string;
  assigned: boolean;
}

export interface MissionFilter extends MissionFilterBase {
  pageNumber: number;
  pageSize: number;
  sortDescending: boolean;
  sortField: string;
  operationId?: number;
  hiddenColumns: string[];
}

export interface MissionContextType {
  data: MissionContainer;
  reload: () => void;
  loading: boolean;
}

export interface OperationMissionForm {
  operationId?: number;
  missionId?: number;
  missionNumber: string;
  startDate: Date | null;
  endDate: Date | null;
  country: string;
  destinationCountry: string;
  objective: string;
  members: User[];
}

export interface CreateMission {
  id?: number;
  operationId: number;
  type: string;
  startDate: Date;
  endDate: Date;
  country: string;
  destinationCountry: string;
  objective: string;
  membersEmails: string[];
}
